import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

// Informational card-event warning: fires when an operator's click can't be
// logged as-is — a rapid repeat click on a card still mid-write (duplicate),
// or a double yellow attempted before a first yellow is on the player. These
// are live human clicks, not automated writes, so we tell the op why rather
// than silently blocking. There's only ever an OK button: the click that
// triggered this has already been rejected (see LineupPanel handleCardAction),
// so there's nothing left to "continue" — this dialog is purely a notice.
const CardDuplicateConfirmDialog = ({ open, title, message, onClose }) => (
  <Dialog
    open={open}
    onClose={(event, reason) => {
      if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      onClose();
    }}
    maxWidth="xs"
    fullWidth
    PaperProps={{
      sx: {
        backgroundColor: '#1E1E1E',
        borderRadius: 3,
        border: '1px solid rgba(255, 255, 255, 0.12)',
      },
    }}
  >
    <DialogTitle
      sx={{
        color: '#FFFFFF',
        fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif',
        fontSize: 20,
        fontWeight: 600,
        pb: 1,
      }}
    >
      {title}
    </DialogTitle>
    <DialogContent>
      <Typography sx={{ color: 'rgba(255,255,255,0.8)', fontSize: 14, fontFamily: '"Barlow", "Roboto", "Helvetica", Arial, sans-serif' }}>
        {message}
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button
        onClick={onClose}
        variant="contained"
        sx={{
          backgroundColor: '#FCC144',
          color: '#000',
          fontWeight: 600,
          textTransform: 'none',
          '&:hover': { backgroundColor: '#e6ad33' },
        }}
      >
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

CardDuplicateConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

export default CardDuplicateConfirmDialog;
